import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

function detectDefault() {
  const saved = localStorage.getItem("cpenz_lang");
  if (saved === "EN" || saved === "IT") return saved;
  const nav = (navigator.language || "en").toLowerCase();
  return nav.startsWith("it") ? "IT" : "EN";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectDefault);

  useEffect(() => {
    localStorage.setItem("cpenz_lang", lang);
    document.documentElement.lang = lang.toLowerCase();
  }, [lang]);

  const setLang = useCallback((l) => setLangState(l), []);

  const t = useCallback(
    (path, vars) => {
      const parts = path.split(".");
      let node = translations[lang];
      for (const p of parts) {
        node = node?.[p];
        if (node === undefined) break;
      }
      if (node === undefined) return path;
      if (typeof node === "string" && vars) {
        return node.replace(/\{(\w+)\}/g, (_, k) => (vars[k] ?? `{${k}}`));
      }
      return node;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
